import { Stack, Switch, Typography, styled } from '@mui/material';
import _ from 'lodash';
import React from 'react';

interface Props {
  checked: boolean;
  disabled?: boolean;
  /** Legacy prop – rendered as a label before the switch */
  leftLabel?: string;
  /** Legacy prop – rendered as a label after the switch */
  rightLabel?: string;

  onClick?(event: any): void;
  onChange?(event: any): void;
}

const StyledSwitch = styled(Switch)(({ theme }) => ({
  '& .MuiSwitch-switchBase': {
    '&.Mui-checked': {
      '& .MuiSwitch-thumb': {
        background: `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
      },
      '& + .MuiSwitch-track': {
        opacity: 1,
        background: '#FFF',
        border: `2px solid ${theme.palette.primary.main}`,
      },
    },
    '&.Mui-disabled': {
      '& .MuiSwitch-thumb': {
        background: theme.palette.greys.light,
      },
      '& + .MuiSwitch-track': {
        opacity: 1,
        background: '#FFF',
        border: `2px solid ${theme.palette.greys.lighter}`,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    background: theme.palette.greys.lighter,
  },
}));

const PaiSwitch: React.FC<Props> = ({ checked, disabled, leftLabel, rightLabel, onClick, onChange }) => {
  const switchEl = (
    <StyledSwitch
      checked={checked}
      size={'small'}
      onClick={(event: React.MouseEvent) => {
        event.stopPropagation();
        if (!_.isNil(onClick)) {
          event.preventDefault();
          onClick(event);
        }
      }}
      onChange={onChange}
      disabled={disabled}
    />
  );

  if (leftLabel || rightLabel) {
    return (
      <Stack direction="row" alignItems="center" spacing={1}>
        {leftLabel && <Typography variant="body2">{leftLabel}</Typography>}
        {switchEl}
        {rightLabel && <Typography variant="body2">{rightLabel}</Typography>}
      </Stack>
    );
  }

  return switchEl;
};

export default PaiSwitch;
